// Generated by CoffeeScript 2.7.0
var EditOption, option_group_item_comp, option_group_item_mixin;

option_group_item_mixin = {
  props: {
    option: {
      type: [Skylark.App.Model.SelectOption, Skylark.App.Model.SelectOptionProxy],
      required: true
    },
    selectedOption: {
      type: Object,
      default: function() {
        return {};
      }
    },
    disabled: {
      type: Boolean
    }
  },
  data: function() {
    return {
      checkedValue: null,
      valid: true
    };
  },
  computed: {
    label: function() {
      return this.option.label;
    },
    checked: function() {
      return this.selectedOption === this.option;
    },
    optionDisabled: function() {
      return this.disabled || this.option._status === 'disabled';
    }
  },
  watch: {
    checkedValue: function(val) {
      this._testAllocatedAmount(this.checkedValue);
      return this.$emit('checkedChange', this.option, !this.checked, this.checkedValue);
    }
  },
  methods: {
    _testAllocatedAmount: function(val) {
      var reg;
      reg = /^(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/;
      if (!reg.test(val)) {
        if (val) {
          return this.checkedValue = Math.floor(Math.abs(val) * 100) / 100;
        } else {
          return this.checkedValue = null;
        }
      }
    }
  }
};

option_group_item_comp = {
  name: 'option-group-item',
  mixins: [option_group_item_mixin],
  template: `<label class='option-group-item with-other' :disabled='optionDisabled'>
  <input type='checkbox'
        hidden='true'
        :checked='checked'
        :disabled='optionDisabled'
        @click.stop='checkedChangeFunc' />
  <i class='slp-circle-o'></i>
  <span class='item-label'>{{ label }}</span>
  <div class='item-input'>
    <input :class="{'has-input' : checked, 'error-input': !valid }"
           v-model.number="checkedValue"
           class="option-group-item-input"
           @input="inputFunc"
           placeholder='请输入'
           type='number'/>
    <div :class="{'has-message' : checked && !valid}" class="message">请填写额度并大于0</div>
  </div>
</label>`,
  methods: {
    checkedChangeFunc: function(event) {
      if (this.checked) {
        event.preventDefault();
      }
      if (this.optionDisabled) {
        return;
      }
      return setTimeout(() => {
        return this.$emit('checkedChange', this.option, !this.checked, this.checkedValue);
      });
    },
    inputFunc: function() {
      return this.validate();
    },
    validate: function() {
      if (this.checked && !this.checkedValue) {
        return this.valid = false;
      } else {
        return this.valid = true;
      }
    }
  }
};

export default EditOption = Vue.extend({
  components: {
    'group-option-item': option_group_item_comp
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    initialValue: {
      type: Object,
      default: function() {
        return {};
      }
    },
    canCancelSingleSelect: {
      type: Boolean,
      default: function() {
        return true;
      }
    }
  },
  template: `<div class='option-group'>
  <group-option-item v-for='option in options'
                    :key='option.uuid'
                    :option='option'
                    :selectedOption='value'
                    @checkedChange='checkedChangeFunc'
                    ref="optionItemRef"/>
</div>`,
  data: function() {
    return {
      value: this.initialValue,
      checkedValue: ''
    };
  },
  watch: {
    initialValue: function() {
      return this.reset();
    },
    value: {
      handler: function() {
        return this.$emit('valueChange', this.value, this.checkedValue);
      },
      immediate: true
    },
    checkedValue: {
      handler: function() {
        return this.$emit('valueChange', this.value, this.checkedValue);
      },
      immediate: true
    }
  },
  methods: {
    checkedChangeFunc: function(option, checked, value) {
      this.value = checked || !this.canCancelSingleSelect ? option : null;
      return this.checkedValue = value;
    },
    reset: function() {
      return this.value = this.initialValue.slice(0);
    },
    validate: function() {
      return _.each(this.$refs.optionItemRef, function(option) {
        if (option.checked) {
          return option.validate();
        }
      });
    }
  }
});
